import { Box, Paper, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";

const IntelIpsPanel = ({ externalIps = [], paper_sx }) => (
  <Paper sx={{ ...paper_sx, minHeight: 420, p: 2, borderRadius: "15px" }} elevation={3}>
    <Typography sx={{ fontSize: 13, fontWeight: 500, color: "#888", mb: 1.5 }}>
      IPs detected (intelligence)
    </Typography>

    {externalIps.length > 0 ? (
      <Box sx={{ height: 360, minWidth: 0 }}>
        <BarChart
          height={360}
          layout="horizontal"
          series={[{ data: externalIps.map((r) => r.count), color: "#459296" }]}
          xAxis={[{ tickLabelStyle: { fontSize: 10, fill: "#888" } }]}
          yAxis={[{
            scaleType: "band",
            data: externalIps.map((r) => r.ip),
            width: 130,
            tickLabelStyle: { fontSize: 11, fill: "#b0b0b0", fontFamily: "monospace" },
          }]}
          margin={{ top: 10, right: 50, bottom: 30, left: 0 }}
          slotProps={{ legend: { style: { display: "none" } } }}
        />
      </Box>
    ) : (
      <Typography variant="body2" sx={{ color: "#777", py: 4, textAlign: "center" }}>
        No external hosts in the selected window.
      </Typography>
    )}
  </Paper>
);

export default IntelIpsPanel;
